import { useState } from 'react';
import type { DashaPeriod, VimshottariResult } from '@astrally/shared';

const fmt = (iso: string) => iso.slice(0, 10);
const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

function isActive(p: DashaPeriod): boolean {
  const now = Date.now();
  return now >= Date.parse(p.startISO) && now < Date.parse(p.endISO);
}

function PeriodRow({ period, depth }: { period: DashaPeriod; depth: number }) {
  const [open, setOpen] = useState(depth === 0 && isActive(period));
  const active = isActive(period);
  const levelName = ['Mahadasha', 'Antardasha', 'Pratyantardasha'][period.level - 1];

  return (
    <div style={{ marginLeft: depth * 14 }}>
      <div
        className="spread"
        style={{
          padding: '8px 10px',
          borderRadius: 10,
          cursor: period.children ? 'pointer' : 'default',
          background: active ? 'var(--accent-soft)' : 'transparent',
          border: active ? '1px solid var(--accent-line)' : '1px solid transparent',
          marginBottom: 3,
        }}
        onClick={() => period.children && setOpen(!open)}
      >
        <div className="row">
          {period.children && (
            <span className="faint tiny">{open ? '▾' : '▸'}</span>
          )}
          <span className={active ? 'gold' : ''} style={{ fontWeight: active ? 700 : 500, fontSize: '0.87rem' }}>
            {cap(period.lord)}
          </span>
          <span className="tiny faint">{levelName}</span>
          {active && <span className="tiny" style={{ color: 'var(--ok)' }}>● now</span>}
        </div>
        <span className="tiny muted">
          {fmt(period.startISO)} → {fmt(period.endISO)}
        </span>
      </div>
      {open &&
        period.children?.map((child, i) => (
          <PeriodRow key={i} period={child} depth={depth + 1} />
        ))}
    </div>
  );
}

export function DashaTimeline({ vim, note }: { vim: VimshottariResult; note?: string }) {
  return (
    <div className="card">
      <div className="h3" style={{ marginBottom: 4 }}>Vimshottari dasha</div>
      <div className="tiny muted" style={{ marginBottom: 10 }}>
        Moon in {vim.moonNakshatra.name} · balance at birth {vim.balanceYears.toFixed(2)}y ·{' '}
        {vim.yearDays}-day years
        {note ? ` · ${note}` : ''}
      </div>
      {vim.periods.map((p, i) => (
        <PeriodRow key={i} period={p} depth={0} />
      ))}
    </div>
  );
}
